export default "__VITE_ASSET__6wUt0tOw__"